export default {
  useI18n: true,
};
